export const REPLACE_CATEGORIES = "REPLACE_CATEGORIES";
export const SET_CATEGORIES_PAGESIZE = "SET_CATEGORIES_PAGESIZE";
export const SET_CATEGORIES_PAGENUMBER = "SET_CATEGORIES_PAGENUMBER";
export const SET_CATEGORIES_TEXTFILTER = "SET_CATEGORIES_TEXTFILTER"

export const replaceCategories = (values, totalResults, totalPage) => ({
    type: REPLACE_CATEGORIES,
    categories: values,
    totalResults,
    totalPage,
});

export const setPageSize = (pageSize) => ({
    type: SET_CATEGORIES_PAGESIZE,
    pageSize,
});
export const setTextFilter = (textFilter) => ({
    type: SET_CATEGORIES_TEXTFILTER,
    textFilter,
});
export const setPageNumber = (pageNumber) => ({
    type: SET_CATEGORIES_PAGENUMBER,
    pageNumber,
});